import { StateToken } from '@ngxs/store';

import {
  BaseDiner,
  Department,
  GetEndOfDaysCountsResponse,
  GetPosEndOfDayTicketsResponse,
  PaymentMethodOptionId,
  StateObject
} from 'src/app/models';

export interface CtdSelectedDepartmentAccount {
  department: Department;
  chargeAccountId: number;
}

interface SelectedTicketAndData {
  selectedPaymentMethod?: PaymentMethodOptionId;
  btrDiner?: BaseDiner;
  selectedDinerChargeAccountId?: number;
  selectedDepartmentAccount?: CtdSelectedDepartmentAccount;
}

export interface ClosingTheDayStateModel {
  endOfDaysCounts: StateObject<GetEndOfDaysCountsResponse>;
  tickets: StateObject<GetPosEndOfDayTicketsResponse>;
  selectedTicketAndData: StateObject<Partial<SelectedTicketAndData>>;
}

export const CLOSING_THE_DAY_STATE_TOKEN =
  new StateToken<ClosingTheDayStateModel>('closingTheDay');
